export default __webpack_public_path__ + "static/media/enterprise.73fe3967.mp4";